import { filterNavigation } from './navigation';
import { Environment } from './environment.types';
import productionEnvironment from './environment.production';

const environment: Partial<Environment> = {
  ...productionEnvironment,
  apiBaseUrl: 'https://venavitals-qms-api.sierralabs.com/api/',
  navigation: filterNavigation(
    'Dashboard',
    'Training Admin',
    'Documents',
    'Products',
    'Supplier Management',
    'Teams',
    'Employees',
    'Workflow',
    'Task Types'
  ),
  productConfig: {
    userNeed: { disableRelations: ['validations', 'verifications'] },
    designInput: {
      disableRelations: ['validations', 'verifications', 'designSpecs']
    },
    designOutput: {
      disableRelations: ['validations', 'verifications', 'designSpecs']
    }
  },
  riskConfig: {
    hideCategory: true
  }
};

export default environment;
